<template>
<main class="container-1">
    <!--
    <h2>Capas</h2>
    <img alt="Vue logo" src="../../assets/img/logo.png">
    -->

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <!-- <h2>Listado</h2> -->
        <TabNav :links="routesNav" @action="handleTabAction" />
    </div>

    <div class="container-body">

        <div v-if="orderFeedback" class="order-feedback" role="status">
            {{ orderFeedback }}
        </div>

        <div class="table-toolbar">
            <div class="toolbar-left">
                <label>
                    Mostrar registros:
                    <select v-model="pageSize" @change="onPageSizeChange">
                        <option :value="10">10</option>
                        <option :value="15">15</option>
                        <option :value="25">25</option>
                        <option :value="50">50</option>
                        <option :value="100">100</option>
                    </select>
                </label>
            </div>
            <div class="toolbar-right">
                <label>
                    Buscar:
                    <input
                        type="text"
                        v-model="searchQuery"
                        @keyup="onSearchKeyup"
                        placeholder="Buscar categoría..."
                    />
                </label>
            </div>
            <div class="toolbar-clear">
                <button
                    v-if="hasActiveFilters"
                    type="button"
                    class="filters-clear-btn"
                    @click="clearFilters"
                >
                    Limpiar filtros
                </button>
            </div>
        </div>

        <table class="categories-table">
            <thead>
                <tr>
                    <th class="sortable" @click="onSort('name')">
                        Nombre <font-awesome-icon :icon="getSortIcon('name')" />
                    </th>
                    <th>Descripción</th>
                    <th class="sortable" @click="onSort('created_at')">
                        Fecha de creación <font-awesome-icon :icon="getSortIcon('created_at')" />
                    </th>
                    <th>Acciones</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in categories" :key="item.id">
                    <td>{{ item.name }}</td>
                    <td>{{ item.desc }}</td>
                    <td>{{ categoryDateFormatter(item.created_at) }}</td>
                    <td class="action-cell">
                        <div class="action-cell__buttons">
                            <router-link :to="'/capas/categorias-de-capas/' + item.id" class="btn-action btn-ver">
                                <font-awesome-icon icon="eye" /> Ver
                            </router-link>
                            <router-link :to="'/capas/categorias-de-capas/' + item.id + '/editar-categoria'" class="btn-action btn-edit">
                                Editar
                            </router-link>
                            <router-link :to="'/capas/categorias-de-capas/' + item.id + '/eliminar-categoria'" class="btn-action btn-delete">
                                Eliminar
                            </router-link>
                        </div>
                    </td>
                </tr>
                <tr v-if="!categories || categories.length === 0">
                    <td colspan="4">No hay categorías</td>
                </tr>
            </tbody>
        </table>

        <Pagination
        v-show="totalPages!=0"
        v-bind:totalPages="totalPages"
        v-bind:currentPage="currentPage"
        v-bind:pageSize="pageSize"
        v-on:pagechanged="pageChangedClick"
        >
        </Pagination>

    </div>

    <CategoryOrderModal ref="categoryOrderModal" @saved="onCategoryOrderSaved" />

    <!-- <SideNav
    class="container-sidenav"
    v-bind:links="routesNav"
    >
    </SideNav> -->

</main>
</template>

<script>
// @ is an alias to /src
import SideNav from '@/components/SideNav.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import TabNav from '@/components/TabNav.vue'
import Pagination from '@/components/Pagination.vue'
import CategoryOrderModal from '@/views/categories/CategoryOrderModal.vue'

import {formatter} from '@/components/mixin/formatter.js'
import {pagination} from '@/components/mixin/pagination.js'
import {restCategory} from '@/components/mixin/restCategory.js'

export default{
    name: 'test',
    mixins: [formatter, pagination, restCategory],
    data(){
        return{
            categories: [],
            searchQuery: '',
            debounceTimer: null,
            sortKey: '',
            sortOrder: 'asc',
            pageSize: 15,
            orderFeedback: '',
            orderFeedbackTimer: null
        }
    },
    components:{
        SideNav,
        Breadcrumb,
        Pagination,
        TabNav,
        CategoryOrderModal
    },
    computed: {
        hasActiveFilters: function(){
            return this.searchQuery !== '' || this.sortKey !== ''
        },
        routesNav: function(){
          return [
                {name:'Opciones'},
                {name:'Crear categoría' , path: '/capas/categorias-de-capas/nueva-categoria'},
                {name:'Definir Orden', action: 'define-category-order', icon: 'sort'},
              ]
        },
        routesBread: function(){
          return [
              {name: 'Capas', path: '/capas' },
              {name: 'Categorías'}
          ]
        }
    },
    props: [],
    methods:{
        handleTabAction(action) {
            if (action === 'define-category-order') this.openCategoryOrder()
        },
        openCategoryOrder() {
            this.orderFeedback = ''
            this.$refs.categoryOrderModal.show()
        },
        onCategoryOrderSaved() {
            this.sortKey = ''
            this.sortOrder = 'asc'
            this.currentPage = 1
            this.fetchCategories()
            this.orderFeedback = 'El orden de las categorías fue actualizado correctamente.'
            clearTimeout(this.orderFeedbackTimer)
            this.orderFeedbackTimer = setTimeout(() => {
                this.orderFeedback = ''
            }, 5000)
        },
        fetchCategories() {
            this.getCategoriesPages(this.currentPage, this.searchQuery, this.sortKey, this.sortOrder, this.pageSize)
        },
        pageChangedClick: function (page){
            this.currentPage = page;
            this.fetchCategories();
        },
        onSearchKeyup() {
            clearTimeout(this.debounceTimer)
            this.debounceTimer = setTimeout(() => {
                this.currentPage = 1
                this.fetchCategories()
            }, 300)
        },
        onPageSizeChange() {
            this.currentPage = 1
            this.fetchCategories()
        },
        onSort(key) {
            if (this.sortKey === key) {
                this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc'
            } else {
                this.sortKey = key
                this.sortOrder = 'asc'
            }
            this.currentPage = 1
            this.fetchCategories()
        },
        getSortIcon(key) {
            if (this.sortKey !== key) return 'sort'
            return this.sortOrder === 'asc' ? 'sort-up' : 'sort-down'
        },
        clearFilters() {
            clearTimeout(this.debounceTimer)
            this.searchQuery = ''
            this.sortKey = ''
            this.sortOrder = 'asc'
            this.currentPage = 1
            this.fetchCategories()
        },
        categoryDateFormatter(date) {
            if (!date || this.moment(date).year() <= 1) return '—'
            return this.dateFormatter(date)
        }
    },
    updated () {

    },
    created () {
        this.$store.getters.getPermissions.layers? true:this.$router.push('/pagina-no-encontrada')
    },
    mounted () {
        this.fetchCategories();
    },
    beforeDestroy () {
        clearTimeout(this.debounceTimer)
        clearTimeout(this.orderFeedbackTimer)
    }
}
</script>

<style lang="scss" scoped>
.order-feedback {
  margin-bottom: 0.8rem;
  padding: 0.65rem 0.8rem;
  border: 1px solid #a9d4ba;
  border-radius: 4px;
  background: #edf8f1;
  color: #24633b;
  font-size: 0.84rem;
}

.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  gap: 1em;
  margin-bottom: 1em;
}

/*
Alinear "Mostrar registros" & "Buscar" segun observacion SENAPRED 06/2026 ("2. Los selectores: "Mostrar" y "Filtro de grupo" no se encuentran alineados y tampoco tienen el mismo tamaño de texto:" y "3. El "Buscador de texto" no se encuentra alineado.")
1. Dedicar un div para cada herramienta
2. Agregar </label> para cada div (eso permite que cada div tenga el mismo "contenido" a nivel de estilo)
*/
.toolbar-left,
.toolbar-right,
.toolbar-clear{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 0.75em;
}

.table-toolbar label {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.toolbar-right{
    flex: 1;
    justify-content: flex-start;
}

.toolbar-right input {
    width: 100%;
    max-width: 220px;   // choose your preferred size
    min-width: 180px;
}

.categories-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 1em;
}

//Observacion SENAPRED 06/2026 ("4. La tabla tiene los textos muy grandes. Quizás podría ser mas pequeño y así mostrar mas registros.")
.categories-table th,
.categories-table td {
  padding: 0.6em 0.8em;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  text-align: left;
  vertical-align: middle;
  font-size: 0.875em;
}

.categories-table thead th {
  background: var(--color-navy);
  color: #fff;
  white-space: nowrap;
  font-weight: 600;
}

.categories-table th.sortable {
  cursor: pointer;
  user-select: none;
}

.categories-table th.sortable:hover {
  background: var(--color-steel);
}

.categories-table tbody tr:hover {
  background: rgba(59, 110, 148, 0.06);
}

.categories-table td.action-cell {
  white-space: nowrap;
}

.action-cell__buttons {
  display: flex;
  flex-wrap: nowrap;
  gap: 0.4em;
  align-items: center;
}

.btn-action {
  display: inline-flex;
  align-items: center;
  gap: 0.25em;
  padding: 0.2em 0.55em;
  border-radius: 3px;
  font-size: 0.82em;
  font-weight: 500;
  text-decoration: none;
  white-space: nowrap;
  transition: opacity 0.12s;
  &:hover { opacity: 0.8; text-decoration: none; }
}

.btn-ver    { background: #e8f4fd; color: var(--color-navy); }
.btn-edit   { background: #fef9e7; color: #7d6608; }
.btn-delete { background: #fdf2f2; color: #922b21; }

.categories-table td:nth-child(3) {
  white-space: nowrap;
}
</style>
